import { EOrderStatus } from '@mahawi/eshop-common/src/types';
import React from 'react';

import OrderLayout from '../../components/orders/orders-layout';

function OrdersCancelledContainer(): React.ReactElement {
  return <OrderLayout orderStatusTypeCodes={[EOrderStatus.CANCELLED]} />;
}

export default OrdersCancelledContainer;
